module.exports = __webpack_public_path__ + "static/img/service.2a0a04c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/service.jpg
// module id = guws
// module chunks = 0